import { Component, inject } from '@angular/core'
import { PricingService } from 'src/app/features/pricing-history/services/pricing.service'
import { TableComponent } from 'src/app/features/pricing-history/table/table.component'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { finalize } from 'rxjs'
import { MessageService } from 'primeng/api'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { SearchComponent } from '../../shared/components/search/search.component'
import { GraphComponent } from './graph/graph.component'
import { LoadingIndicatorComponent } from 'src/app/shared/components/ui/loading-indicator/loading-indicator.component'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-pricing-history',
  template: `
    <div class="search-bar raisedbox">
      <div class="search-bar-container">
        <p>
          <mat-slide-toggle
            [checked]="showViewQuoteHistory"
            labelPosition="before"
            (change)="showViewQuoteHistory = !showViewQuoteHistory"
            >Quote History</mat-slide-toggle
          >
        </p>
        <app-search
          class="search-bar-input"
          [searchValue]="searchValue"
          [options]="materialOptions"
          (onSearch)="handleSearch($event)"
          [selectedOption]="selectedMaterialOption"
          placeholder="Enter Material Id"></app-search>
      </div>
      <div>
        <span
          style="padding-right: 2rem"
          (click)="setDataView(dataViewMapping.table)">
          <svg
            class="toggle"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            [ngClass]="
              dataView === dataViewMapping.table ? ' toggle-active' : ' '
            ">
            <mask
              id="mask0_257_6378"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24">
              <rect width="24" height="24" />
            </mask>
            <g mask="url(#mask0_257_6378)">
              <path
                d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 8.325H19V5H5V8.325ZM5 13.675H19V10.325H5V13.675ZM5 19H19V15.675H5V19ZM6 7.65V5.65H8V7.65H6ZM6 13V11H8V13H6ZM6 18.35V16.35H8V18.35H6Z" />
            </g>
          </svg>
        </span>
        <span
          style="padding-right: 2rem"
          (click)="setDataView(dataViewMapping.graph)">
          <svg
            class="toggle"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            [ngClass]="
              dataView === dataViewMapping.graph ? ' toggle-active' : ' '
            ">
            <mask
              id="mask0_257_6381"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24">
              <rect width="24" height="24" />
            </mask>
            <g mask="url(#mask0_257_6381)">
              <path
                d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 16.95V19H19V10.25L13.05 17L9 12.95L5 16.95ZM5 14.1L9 10.1L12.95 14.05L19 7.25V5H5V14.1ZM5 10.25V7.25V14.05V10.1V16.95V12.95V17V10.25ZM5 14.1V5V14.05V10.1V14.1ZM5 16.95V12.95V17V10.25V19V16.95Z" />
            </g>
          </svg>
        </span>
        <span class="toggle disabled" style="padding-right: 2rem">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <mask
              id="mask0_257_6384"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24">
              <rect width="24" height="24" />
            </mask>
            <g mask="url(#mask0_257_6384)">
              <path
                d="M2.625 18.175L1 17L6 9L9 12.5L13 6L15.725 10.075C15.3417 10.0917 14.9792 10.1375 14.6375 10.2125C14.2958 10.2875 13.9583 10.3917 13.625 10.525L13.075 9.7L9.275 15.875L6.25 12.35L2.625 18.175ZM21.575 23L18.45 19.875C18.1167 20.1083 17.7458 20.2833 17.3375 20.4C16.9292 20.5167 16.5083 20.575 16.075 20.575C14.825 20.575 13.7625 20.1375 12.8875 19.2625C12.0125 18.3875 11.575 17.325 11.575 16.075C11.575 14.825 12.0125 13.7625 12.8875 12.8875C13.7625 12.0125 14.825 11.575 16.075 11.575C17.325 11.575 18.3875 12.0125 19.2625 12.8875C20.1375 13.7625 20.575 14.825 20.575 16.075C20.575 16.5083 20.5167 16.9292 20.4 17.3375C20.2833 17.7458 20.1083 18.125 19.875 18.475L23 21.575L21.575 23ZM16.075 18.575C16.775 18.575 17.3667 18.3333 17.85 17.85C18.3333 17.3667 18.575 16.775 18.575 16.075C18.575 15.375 18.3333 14.7833 17.85 14.3C17.3667 13.8167 16.775 13.575 16.075 13.575C15.375 13.575 14.7833 13.8167 14.3 14.3C13.8167 14.7833 13.575 15.375 13.575 16.075C13.575 16.775 13.8167 17.3667 14.3 17.85C14.7833 18.3333 15.375 18.575 16.075 18.575ZM18.3 10.575C17.9833 10.4417 17.6542 10.3333 17.3125 10.25C16.9708 10.1667 16.6167 10.1167 16.25 10.1L21.375 2L23 3.175L18.3 10.575Z" />
            </g>
          </svg>
        </span>
      </div>
    </div>

    <app-loading-indicator *ngIf="loading"></app-loading-indicator>

    <div
      class=""
      style="height: 65%; width: 100%"
      *ngIf="dataView === dataViewMapping.table">
      <app-table
        *ngIf="!loading && tableData"
        [showQuoteHistory]="showViewQuoteHistory"
        [tableData]="tableData"
        [tableTitle]="resultTableTitle"
        [materialId]="tableTitle"
        [quoteDetail]="selectedQuoteDetail"
        (onRowExpanded)="getQuotes($event)"
        [loading]="loadingQuotes"></app-table>
    </div>

    <div
      *ngIf="dataView === dataViewMapping.graph"
      style="padding: 0rem 0.5rem">
      <app-graph
        [showQuoteHistory]="showViewQuoteHistory"
        [graphData]="graphData"></app-graph>
    </div>

    <div *ngIf="!isDataAvailable && !loading">
      <div class="container text-center" style="height: 100%; width: 100%">
        <div class="row" style="height: 100%">
          <div class="col" style="margin-top: 10rem">
            <h2 class="color-primary mb-3">
              No data to display, please enter material id to fetch data.
            </h2>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .search-bar {
        background: #fff;
        padding: 1.6rem 1rem 1.6rem 1.4rem;
        display: flex;
        align-items: baseline;
        justify-content: space-between;

        &-container {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        &-input {
          margin-bottom: 1rem;
        }
      }
    `,
  ],
  standalone: true,
  imports: [
    TableComponent,
    CommonModule,
    FormsModule,
    LoadingIndicatorComponent,
    SearchComponent,
    GraphComponent,
    MatSlideToggleModule,
  ],
})
export class PricingHistoryComponent {
  isDataAvailable = false
  tableTitle = ''
  tableData!: any[]
  graphData!: any[]
  resultTableTitle: string = ''
  loading = false
  loadingQuotes = false
  materialOptions = [
    { name: 'PS1 MATNR', code: 'PS1' },
    { name: 'AP9 MATNR', code: 'AP9' },
  ]
  selectedMaterialOption = { name: 'PS1 MATNR', code: 'PS1' }
  viewOptions = [
    { label: 'Historical', value: 'HST' },
    { label: 'Quote Historical', value: 'QHST' },
  ]
  showViewQuoteHistory = false
  dataViewMapping = {
    table: 'tableView',
    graph: 'graphview',
    queryStat: 'queryStat',
  }
  dataView = this.dataViewMapping.table
  selectedQuoteDetail = null
  searchValue: string | undefined

  private messageService = inject(MessageService)
  private pricingService = inject(PricingService)

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe((params) => {
      if (params.hasOwnProperty('materialId')) {
        this.searchValue = params['materialId']
        this.showViewQuoteHistory = params['quoteHistory'] === 'true'
        this.handleSearch({
          selectedOption: this.selectedMaterialOption,
          searchValue: params['materialId'],
        })
      }
    })
  }

  tableHasData() {
    this.isDataAvailable = Object.keys(this.tableData).length > 0
  }

  handleSearch(query: any) {
    const material = query.selectedOption.code
    if (material === 'PS1') {
      this.getPS1(query.searchValue)
    } else if (material === 'AP9') {
      this.getAP9(query.searchValue)
    }
    this.tableTitle = query.searchValue
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        materialId: query.searchValue,
        quoteHistory: this.showViewQuoteHistory,
      },
    })
  }

  getPS1(id: string) {
    this.loading = true
    this.tableData = []
    this.resultTableTitle = 'Result for PS1 Mapped Material ID:'

    let priceService

    if (!this.showViewQuoteHistory)
      priceService = this.pricingService.getPS1(id)
    else {
      priceService = this.pricingService.getQuotePS1(id)
    }
    priceService.pipe(finalize(() => (this.loading = false))).subscribe({
      next: (result: any) => {
        this.handleSetData(
          this.showViewQuoteHistory ? result : JSON.parse(result)
        )
        this.tableHasData()
        console.log(this.tableData)
        if (this.isDataAvailable) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        } else {
          this.messageService.add({
            severity: 'warning',
            summary: 'Warning',
            detail: 'No entries found.',
          })
        }
      },
      error: (e) => {
        console.log(e)
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There is some error while processing your request.',
        })
        this.tableHasData()
      },
    })
  }

  getAP9(id: string) {
    this.loading = true
    this.resultTableTitle = 'Result for AP9 Mapped Material ID:'

    let priceService

    if (!this.showViewQuoteHistory)
      priceService = this.pricingService.getAP9(id)
    else {
      priceService = this.pricingService.getQuoteAP9(id)
    }

    priceService.pipe(finalize(() => (this.loading = false))).subscribe({
      next: (result: any) => {
        this.handleSetData(
          this.showViewQuoteHistory ? result : JSON.parse(result)
        )
        this.tableHasData()
        console.log(this.tableData)
        if (this.isDataAvailable) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        } else {
          this.messageService.add({
            severity: 'warning',
            summary: 'Warning',
            detail: 'No entries found.',
          })
        }
      },
      error: (e) => {
        console.log(e)
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There is some error while processing your request.',
        })
        this.tableHasData()
      },
    })
  }

  setDataView(view: string) {
    this.dataView = view
  }

  handleSetData(data: any[]) {
    const dataCopy = data.map((item) => ({ ...item }))

    dataCopy.forEach((item, index) => {
      item.id = index
      if (!this.showViewQuoteHistory) {
        item['ERDAT'] = item['ERDAT'].replace(
          /(\d{4})(\d{2})(\d{2})/g,
          '$1-$2-$3'
        )
      }
    })

    const sortedByPrice = dataCopy.sort(this.price_sort)

    this.graphData = sortedByPrice.sort(this.custom_sort)
    this.tableData = this.graphData
  }

  price_sort(a: any, b: any) {
    return a.NETPR - b.NETPR
  }

  custom_sort(a: any, b: any) {
    return new Date(a.ERDAT).getTime() - new Date(b.ERDAT).getTime()
  }

  getQuotes(event: any) {
    this.loadingQuotes = true
    this.pricingService
      .getHistoricalQuotes(event.data.VBELN, event.data.POSNR)
      .pipe(finalize(() => (this.loadingQuotes = false)))
      .subscribe({
        next: (data) => {
          console.log(data)
          this.selectedQuoteDetail = data
        },
      })
  }
}
